import { module } from 'modujs'
import { clamp, map } from '../utils/maths'

const ACTIVE_OUT = .75
export default class extends module {
    constructor(m) {
        super(m)

        // Binding
        this.onResizeBind = this.onResize.bind(this)

        // UI
        this.$el = this.el
        this.$items = this.$('item')

        // Data
        this.data = {
            minProgress: 0,
            maxProgress: 1,
            currentProgress: 0,
            allProgressData: [],
            activeIndex: 0
        }
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        this.bindEvents()
        this.initProgressDatas()
        this.computeActiveItem()
        this.computeDefaultValues()
    }

    destroy() {
        this.unbindEvents()
        super.destroy()
    }

    ///////////////
    // Events
    ///////////////
    bindEvents() {
        window.addEventListener('resizeEnd', this.onResizeBind)
    }

    unbindEvents() {
        window.removeEventListener('resizeEnd', this.onResizeBind)
    }

    ///////////////
    // Callbacks
    ///////////////
    onProgress(progress) {
        this.data.currentProgress = progress
        this.computeProgress()
        this.computeActiveItem()
    }

    onResize() {
        if (this.data.currentProgress == 0 || this.data.currentProgress == 1) {
            return
        }

        this.computeProgress()
        this.computeActiveItem()
    }

    inview(e) {
        if (e.way == 'exit') {
            this.data.currentProgress = window.scrollDirection == 'up' ? 0 : 1
            this.computeProgress()
        }
    }

    ///////////////
    // Methods
    ///////////////
    initProgressDatas() {
        const progressPart = 1 / (this.$items.length - 1)

        for (let index = 0; index < this.$items.length; index++) {
            this.data.allProgressData.push({
                minProgress: index * progressPart,
                maxProgress: index * progressPart + progressPart,
                currentProgress: 0,
            })
        }
    }

    computeProgress() {
        // Global progress
        this.data.currentNormalizedProgress = clamp(
            map(this.data.currentProgress, this.data.minProgress, this.data.maxProgress, 0, 1),
            0,
            1
        )

        this.$el.style.setProperty('--global-progress', this.data.currentNormalizedProgress)

        // Each item progress
        for (let index = 0; index < this.$items.length; index++) {
            const currentItem = this.$items[index]
            const currentItemProgressData = this.data.allProgressData[index]
            currentItemProgressData.currentProgress = clamp(
                map(this.data.currentNormalizedProgress, currentItemProgressData.minProgress, currentItemProgressData.maxProgress, 0, 1),
                0,
                1
            )

            // Update next-item visual clip-path
            if (index < this.$items.length - 1) {
                this.$items[index + 1].style.setProperty('--visual-progress', currentItemProgressData.currentProgress)
            }
        }

        // Set active index
        this.data.activeIndex = Math.floor(this.data.currentNormalizedProgress / (1 / (this.$items.length -1)))
    }

    computeActiveItem() {
        const activeItemProgressData = this.data.allProgressData[this.data.activeIndex]

        // Toggle active item if > ACTIVE_OUT
        if (activeItemProgressData.currentProgress > ACTIVE_OUT) {
            this.$items[this.data.activeIndex].classList.remove('is-active')
            this.$items[this.data.activeIndex + 1].classList.add('is-active')
        } else {
            this.$items[this.data.activeIndex + 1].classList.remove('is-active')
            this.$items[this.data.activeIndex].classList.add('is-active')
        }
    }

    computeDefaultValues() {
        this.$el.style.setProperty('--global-progress', 0)
        
        for (let index = 1; index < this.$items.length; index++) {
            this.$items[index].style.setProperty('--visual-progress', 0)
        }
    }
}
